import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var CAPTCHA_URL = '/captcha.ashx?w=140&type=base64';
export var getModalData = function getModalData(_ref) {
  var type = _ref.type,
    data = _ref.data,
    modals = _ref.modals;
  if (type === 'captcha') return data;
  return modals[type] && _objectSpread(_objectSpread({}, data), modals[type]);
};
export var getJsonFromFile = function getJsonFromFile(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.onload = function (event) {
      var _event$target;
      resolve(JSON.parse(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result));
    };
    reader.readAsText(file);
  });
};